import {Component, inject, Injector, OnDestroy, OnInit} from '@angular/core';
import {BasePageComponent} from "@core-components/page-content/base-page.component";
import {ConsoleContextService} from "@security/console-context.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {PageHeaderTab} from "@core-components/page-header/page-header-tabs.interface";
import {Survey} from "../surveys.model";
import {SurveyService} from "../survey.service";
import {lastValueFrom, Subject} from "rxjs";
import {SnackbarService} from "@ui-kit/framework/util/service/snackbar.service";
import {PanelType} from "@shared-components/info-panel/info-panel.component";

/*
  todo  Add an extra tab with the survey details
    - include a form to edit main survey information
 */

@Component({
  selector: 'app-survey-view',
  templateUrl: './survey-view.component.html'
})
export class SurveyViewComponent extends BasePageComponent implements OnInit, OnDestroy {
  private _context = inject(ConsoleContextService);
  private _surveyService = inject(SurveyService);
  private _snackbarService = inject(SnackbarService);
  protected loader = inject(LoadingService);


  private _clearOnDestroy$ = new Subject<void>();
  protected dataPrefetchState : "loading" | "complete" | "error" = "loading";

  protected readonly surveyServiceErrorMessage = 'An error occurred and the survey details could not be loaded. Please refresh the page or try again later.';
  protected readonly PanelType = PanelType;

  protected tabs: PageHeaderTab[] = [
    {
      name: 'Configure',
      isActive: false,
      code: "survey_configuration",
      disabled: false
    },
    // todo - change to default active tab
    {
      name: 'Submissions',
      isActive: true,
      code: "survey_submissions",
      disabled: false
    },
    {
      name: 'Results',
      isActive: false,
      code: "survey_results",
      disabled: false
    }
  ];

  protected activeTab: string = "survey_submissions" // todo - change to default survey_submissions tab

  protected survey: Survey;

  constructor(injector: Injector) {
    super(injector);
    this.survey = this.data.survey;
  }

  ngOnInit(): void {
    this.dataPrefetchState = "loading";

    lastValueFrom(
      this._surveyService.getOneSurvey(this.survey.uuid!)
        .pipe(this.loader.withLoader(this._clearOnDestroy$))
    )
      .then(survey => {
        if (!survey) {
          this.loadingErrorState();
        }
        this.survey = survey;
        this.dataPrefetchState = "complete";
      })
      .catch(err => {
        this.loadingErrorState();
      });

  }

  ngOnDestroy(): void {
    this._clearOnDestroy$.next();
  }

  changeTabs($event: PageHeaderTab): void {
    this.activeTab = $event.code;
  }

  getInitialTab(): PageHeaderTab {
    return this.tabs.at(1)!; //todo change back to 1
  }

  onUpdatedSurvey(updated: Survey): void {
    console.log("SurveyViewComponent.onUpdatedSurvey", updated);
    this.survey = updated;
  }

  private loadingErrorState(){
    this.dataPrefetchState = "error";
    this._snackbarService.openSnackBar(this.surveyServiceErrorMessage);
  }



}
